<template>
<el-dialog :title="title" :visible.sync="dialogFormVisible" width="480px">
  <el-form :model="formData" :rules="rules" ref="ruleForm">
    <el-form-item label="异常报备" :label-width="formLabelWidth" prop="reportRemark">
      <el-input type="textarea" :rows="3" v-model="formData.reportRemark" :maxlength="10" placeholder="请输入异常报备内容" autocomplete="off"></el-input>
    </el-form-item>
  </el-form>
  <div slot="footer" class="dialog-footer">
    <el-button @click="closeDialog">取 消</el-button>
    <el-button type="primary" @click="confirmFun" :loading="confirmLoading">确 定</el-button>
  </div>
</el-dialog>
</template>
<script>
export default {
  name: 'AbnormalReportDialog',
  data(){
    return{
      title: '异常报备',
      dialogFormVisible: false,
      formLabelWidth: '100px',
      formData: {
        reportRemark: undefined
      },
      rules: {
        reportRemark: [
          { required: true, message: '请输入异常报备内容', trigger: ['blur', 'change'] }
        ]
      },
      confirmLoading: false
    }
  },
  methods:{
    opendDialog (rowData) {
      // console.log('===rowData', rowData)
      this.dialogFormVisible = true
      this.orderNo = rowData.orderNo
      this.formData.reportRemark = rowData.reportRemark
    },
    closeDialog () {
      this.dialogFormVisible = false
    },
    confirmFun () {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.abnormalReportReqFun()
        } else {
          console.log('error submit!!');
          return false;
        }
      })
    },
    // 异常报备请求
    abnormalReportReqFun () {
      this.confirmLoading = true
      const url = '/autoapp-default-server-recovery/api/jd/recycle/order/saveReport'
      const params = {
        orderNo: this.orderNo,
        reportRemark: this.formData.reportRemark
      }
      this.HttpService.post(url, params).then(res => {
        // console.log('===res===', res)
        this.confirmLoading = false
        if (res.statusCode == 200) {
          this.$message.success("报备成功")
          this.$emit('report-success')
          this.closeDialog()
        }
      }, error => {
        this.confirmLoading = false
      })
    }
  }
}
</script>
<style scoped lang="scss">
.dialog-footer {
	padding: 16px;
	box-sizing: border-box;
}
</style>


// WEBPACK FOOTER //
// src/views/jdOldMachineRecycleManage/components/AbnormalReportDialog.vue